import { forwardRef } from 'react'
import { Assignee, PostStatusPropertyValue, type PropertyValue } from 'api/clients/PropertyClient'
import Styles from '../PropertyValue.module.scss'
import { isString } from 'lodash'
import { Tag } from 'common/OptionSelect/Tag'
import { PostStatusDropdown } from 'components/PostStatusDropdown/PostStatusDropdown'
import { Pressable } from '@react-aria/interactions'

interface Props {
  propertyValue?: PropertyValue & { value: PostStatusPropertyValue }
  onSelect: (value: PostStatusPropertyValue) => void
  assignee: Assignee
}

const PostStatus = forwardRef<HTMLDivElement, Props>(({ propertyValue, assignee }, ref) => {
  if (!isString(propertyValue?.value)) return <></>

  return (
    <div ref={ref} className={Styles.postStatusContainer}>
      <PostStatusDropdown assignee={assignee}>
        <Pressable>
          <div style={{ width: '100%' }}>
            <div style={{ width: 'fit-content' }}>
              <Tag color={propertyValue?.meta?.color as string}>{propertyValue?.value}</Tag>
            </div>
          </div>
        </Pressable>
      </PostStatusDropdown>
    </div>
  )
})

export default PostStatus
